.сheckoutWrapper {
  margin-top: 12px;
  width: 100%;
  height: auto;
}

.сheckoutWrapper_paymentMethods {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
}

.сheckoutWrapper_paymentMethod {
  position: relative;
  margin-top: 8px;
  width: 100%;
  min-height: 60px;
  border-radius: 16px;
  border: 2px solid #ded9ce;
  // padding: 0 20px;
}

.сheckoutWrapper_paymentMethod.active {
  border-color: var(--ed-border, #00a370);
  background-color: #f2ede1;

  .header {
    position: relative;

    &::after {
      content: '';
      width: calc(100% - 40px);
      height: 1px;
      background-color: #dcd3c1;
      position: absolute;
      bottom: -2px;
      left: 20px;
    }
  }

  .radioLabel {
    img {
      filter: none;
      opacity: 1;
    }
  }
}

.header {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 20px;
}

.radio {
  display: none;
}

.radioLabel {
  position: relative;
  padding-left: 29px;
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    font-size: 17px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0.068px;
  }

  // img {
  //   filter: grayscale(100%);
  //   opacity: 0.7;
  // }
}

.radioLabel::before {
  content: '';
  width: 22px;
  height: 22px;
  border: 2px solid #ddd9cf;
  border-radius: 50%;
  position: absolute;
  left: 1px;
  top: 50%;
  transform: translateY(-50%);
  transition: 0.3s;
}

.radioChecked::before {
  background: url(./img/radio.svg) no-repeat;
  background-position: center;
  background-size: contain;
  border: none; // Цвет рамки активной радиокнопки
}

// .radio:checked + .radioLabel::before {
//   background: url(./img/radio.svg) no-repeat;
//   background-position: center;
//   background-size: contain;
//   border: none; // Цвет рамки активной радиокнопки
// }

.content {
  margin-top: 26px;
  display: none;
  padding: 0 20px 18px 20px;
}

.content.active {
  display: block;
}

.imgWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 10px;

  .secureImg {
    margin-top: 0;
    margin: 0;
  }
}

.error {
  margin-top: 20px;
  font-size: 14px;
  line-height: 16px;
  color: #f76060;
}

.paypalWarnings {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  line-height: 24px;
  color: red;
  text-align: center;
  // margin-top: 10px;
}

.cardsIcon {
  width: 67.17px;
}

.applePayIcn {
  width: 50px;
}

.applePayIcn.gpl {
  width: 61px;
}

.payPalIcon {
  width: 65px;
}

.infoList {
  margin-bottom: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  list-style: none;

  li {
    position: relative;
    margin-top: 12px;
    padding: 0 18px 0 25px;

    &:first-child {
      margin-top: 0;
    }
  }

  .check {
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    width: 16px;
    height: 16px;
    min-width: 16px;
    min-height: 16px;
    background-image: url('./img/check.svg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
  }

  p {
    color: #231e19;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.045px;
  }
}

.exampleButton {
  width: 100%;
  height: 60px;
  background-color: #000;
  border-radius: 60px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.secure {
  margin-top: 12px;
  display: flex;
  width: 77px;
  height: 26px;
  min-width: 77px;
  min-height: 26px;
  background-image: url('./img/srcure.png');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  margin-right: auto;
  margin-left: auto;
}

.buttonwrapper {
  border-radius: 60px;
  overflow: hidden;
  width: 100%;
  height: 60px;
  max-height: 60px;
}

.buttonwrapper.applepay {
  height: auto;
  max-height: 100%;
  overflow: visible;
}

.buttonWrapperPaypal {
  padding-top: 1.5px;
  background-color: #f6c657;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover,
  &:active {
    background-color: #f4bc37;
  }
}

:global body.dark {
  :local {
    .сheckoutWrapper_paymentMethod {
      background: #2a2928;
      border-color: #2a2928;
    }

    .radioLabel p,
    .infoList p {
      color: #fffbf2;
    }

    .сheckoutWrapper_paymentMethod .header {
      &::after {
        background-color: #181716;
      }
    }

    // .radioLabel img, .card-brand {
    //   filter: invert(1) grayscale(100%)!important;
    //   opacity: 1;
    // }
  }
}
